/**
 * @generated SignedSource<<891eed073fb43f0189779f9adc3a57f1>>
 * @relayHash a3846952a6f0c5285569850294d5b2c2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3846952a6f0c5285569850294d5b2c2

import { ConcreteRequest } from 'relay-runtime';
export type AsynchronousQuestionnaireUsage = "ACCEPTED" | "ALL" | "DECLINED";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type CreatePersonalTreatmentPlanTemplateInput = {
  amountOfDays?: number | null;
  asynchronousQuestionnaireUsage?: AsynchronousQuestionnaireUsage | null;
  countries: ReadonlyArray<Country>;
  diagnosisCodes: ReadonlyArray<string>;
  languages: ReadonlyArray<TreatmentPlanTemplateLanguageInput>;
  name: string;
};
export type TreatmentPlanTemplateLanguageInput = {
  followUpInstructions?: string | null;
  language: Language;
  recommendedTreatment?: string | null;
  synonym?: string | null;
  title: string;
};
export type useCreatePersonalTreatmentPlanTemplateMutation$variables = {
  input: CreatePersonalTreatmentPlanTemplateInput;
};
export type useCreatePersonalTreatmentPlanTemplateMutation$data = {
  readonly createPersonalTreatmentPlanTemplate: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly treatmentPlanTemplate: {
      readonly countries: ReadonlyArray<Country>;
      readonly id: string;
      readonly languages: ReadonlyArray<{
        readonly followUpInstructions: string | null;
        readonly language: Language;
        readonly recommendedTreatment: string | null;
        readonly synonym: string | null;
        readonly title: string;
      }>;
      readonly name: string;
    } | null;
  };
};
export type useCreatePersonalTreatmentPlanTemplateMutation = {
  response: useCreatePersonalTreatmentPlanTemplateMutation$data;
  variables: useCreatePersonalTreatmentPlanTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "TreatmentPlanTemplate",
  "kind": "LinkedField",
  "name": "treatmentPlanTemplate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreatmentPlanTemplateLanguage",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followUpInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "synonym",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendedTreatment",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreatePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "createPersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCreatePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "createPersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a3846952a6f0c5285569850294d5b2c2",
    "metadata": {},
    "name": "useCreatePersonalTreatmentPlanTemplateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "95e2e8afa46afee96a92d4c6c5e70dae";

export default node;
